"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _weakMap = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/weak-map"));
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/array/is-array"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/map"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/reduce"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/object/keys"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/for-each"));
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/index-of"));
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/trim"));
var _startsWith = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/starts-with"));
var _uniq2 = _interopRequireDefault(require("lodash/uniq"));
var _isString2 = _interopRequireDefault(require("lodash/isString"));
var _isPlainObject2 = _interopRequireDefault(require("lodash/isPlainObject"));
var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));
var _flatten2 = _interopRequireDefault(require("lodash/flatten"));
var _compact2 = _interopRequireDefault(require("lodash/compact"));
var _dedupe = _interopRequireDefault(require("classnames/dedupe"));
const _block = new _weakMap.default();
const _modifiers = new _weakMap.default();
const _extraClasses = new _weakMap.default();

/**
 * Prepares modifiers, applying data to functions,
 * and flattening arrays
 */
function prepMods(mods, data) {
  var _context;
  // make sure mods is an array
  if (!(0, _isArray.default)(mods)) {
    mods = [mods || null];
  }

  // flatten the array...
  return (0, _compact2.default)((0, _flatten2.default)((0, _map.default)(_context = (0, _flatten2.default)(mods)).call(_context, mod => {
    // ...call function modifiers with data
    if ((0, _isFunction2.default)(mod)) {
      mod = mod(data || {});
    }
    if ((0, _isString2.default)(mod)) {
      mod = mod.split(/\s+/g);
    }
    return mod;
  })));
}

/**
 * Sanitizes extraClasses, applying data to functions,
 * flattening arrays, and converting modifiers to
 * root classes
 */
function prepExtraClasses(classes, elem, data) {
  var _context2;
  if ((0, _isArray.default)(classes)) {
    classes = (0, _map.default)(classes).call(classes, obj => {
      if ((0, _isPlainObject2.default)(obj)) {
        return obj[elem];
      }
      return obj;
    });
  }
  if ((0, _isPlainObject2.default)(classes)) {
    classes = classes[elem];
  }
  return (0, _map.default)(_context2 = prepMods(classes, data)).call(_context2, mods => {
    // make strings into an object
    if ((0, _isString2.default)(mods)) {
      mods = {
        [mods]: true
      };
    }
    if ((0, _isPlainObject2.default)(mods)) {
      var _context3;
      // allow for space-separated keys
      return (0, _reduce.default)(_context3 = (0, _keys.default)(mods).join(' ').split(/\s+/g)).call(_context3, (obj, mod) => {
        var _context4;
        const val = !!mods[mod];

        // break up space-separated class list strings
        (0, _forEach.default)(_context4 = mod.split(/\s+/g)).call(_context4, cls => {
          if ((0, _indexOf.default)(cls).call(cls, '__') !== 0 && (0, _indexOf.default)(cls).call(cls, '--') !== 0) {
            // assume non-prefixed strings are
            // plain classes
            cls = `^${cls.replace(/^\^/, '')}`;
          }
          obj[cls] = val;
        });
        return obj;
      }, {});
    }
    return (0, _compact2.default)(mods);
  });
}
function toClassName(classList) {
  return classList.join(' ');
}
function toSelector(classList) {
  return `.${classList.join('.')}`;
}

/**
 * BEM utility
 *
 * @deprecated Prefer using `makeStyles()` or `withStyles()` over using BEM classes.
 */
class BEM {
  /**
   * Generates an Array of BEM classes
   */
  static createClassList(blocks, elem, ...modifiers) {
    var _context5;
    if (!(0, _isArray.default)(blocks)) {
      blocks = [blocks];
    }
    blocks = (0, _trim.default)(_context5 = (0, _map.default)(blocks).call(blocks, block => {
      if (!(0, _isString2.default)(block) || (0, _trim.default)(block).call(block) === '') {
        throw new Error(`Invalid block (${typeof block})`);
      }
      return (0, _trim.default)(block).call(block);
    }).join(' ')).call(_context5).split(/\s+/);
    if (!elem || !(0, _isString2.default)(elem) || (0, _trim.default)(elem).call(elem) === '^') {
      elem = null;
    }
    const classes = [];
    (0, _forEach.default)(blocks).call(blocks, block => {
      const baseClass = `${block}${elem ? `__${elem}` : ''}`;
      classes.push(baseClass);

      // convert modifiers to an array of classes
      modifiers = (0, _dedupe.default)(...(0, _flatten2.default)(modifiers)).split(/\s+/g);
      (0, _forEach.default)(modifiers).call(modifiers, mod => {
        if ((0, _startsWith.default)(mod).call(mod, '__')) {
          // element class
          classes.push(...BEM.create(block, mod.replace(/^_{2}/, '')).split(/\s+/g));
        } else if ((0, _startsWith.default)(mod).call(mod, '^')) {
          // root class
          classes.push(mod.replace(/^\^/, ''));
        } else {
          // modifier class
          classes.push(`${baseClass}${mod ? `--${mod.replace(/^-{2}/, '')}` : ''}`);
        }
      });
    });
    return (0, _compact2.default)((0, _uniq2.default)(classes));
  }

  /**
   * Generates a space-separated string of BEM classes
   */
  static createClassName(blocks, elem, ...modifiers) {
    return toClassName(this.createClassList(...arguments));
  }

  /**
   * Generates a CSS Selector of BEM classes
   */
  static createSelector(blocks, elem, ...modifiers) {
    return toSelector(this.createClassList(...arguments));
  }

  /**
   * Alias for BEM.createClassName()
   */
  static create(blocks, elem, ...modifiers) {
    return this.createClassName(...arguments);
  }
  get extraClasses() {
    let extraClasses = [];
    try {
      extraClasses = [..._extraClasses.get(this)];
    } catch (e) {
      /*
      	It is possible for the result of `.get()` to not be iterable. This surfaced in Greenhouse's Permissions page.
      	This catch should cause extra classes to default to an empty array.
      */
    }
    return extraClasses;
  }

  /**
   * @constructor
   */
  constructor(blocks, modifiers, extraClasses) {
    if (!(0, _isArray.default)(blocks)) {
      blocks = [blocks];
    }
    const newBlock = (0, _map.default)(blocks).call(blocks, block => {
      if (block instanceof BEM) {
        const parent = block;
        block = _block.get(parent);
        modifiers = [_modifiers.get(parent), modifiers];
        extraClasses = [_extraClasses.get(parent), extraClasses];
      }
      if (!(0, _isString2.default)(block) || (0, _trim.default)(block).call(block) === '') {
        throw new Error(`Invalid block (${typeof block})`);
      }
      return block;
    }).join(' ');
    _block.set(this, newBlock);
    _modifiers.set(this, modifiers || []);
    _extraClasses.set(this, extraClasses || {});
  }

  /**
   * Generates an array of classes, using the instance
   * block, applying root modifiers, passed modifiers,
   * and extraClasses with passed data
   */
  classList(elem, modifiers, data) {
    const block = _block.get(this);
    const extraClasses = _extraClasses.get(this) || [];
    elem = elem || '^';
    modifiers = [...prepMods(modifiers, data), ...prepMods(_modifiers.get(this), data), ...prepExtraClasses(extraClasses, elem, data)];
    return this.constructor.createClassList(block, elem, modifiers);
  }

  /**
   * Generates a space-separated string of classes, using the instance
   * block, applying root modifiers, passed modifiers,
   * and extraClasses with passed data
   */
  className(elem, modifiers, data) {
    return toClassName(this.classList(...arguments));
  }

  /**
   * Generates a CSS selector of classes, using the instance
   * block, applying root modifiers, passed modifiers,
   * and extraClasses with passed data
   */
  selector(elem, modifiers, data) {
    return toSelector(this.classList(...arguments));
  }

  /**
   * Alias for .className()
   */
  elem(elem, modifiers, data) {
    return this.className(...arguments);
  }

  /**
   * Generates a string of root classes
   *
   * Shortcut for .className('^', modifiers, data)
   */
  mod(modifiers, data) {
    return this.className('^', modifiers, data);
  }
}
exports.default = BEM;